export default (pluginName) => {
let file = `import { add } from 'dek'

export let name          =  '${pluginName}'
export let version       =  'v0.1.0'
export let dependencies  =  []

export default async (arg) => {

    add('${pluginName}', async () => {
        
    })

}

export let cli = {
    name: '${pluginName}',
    action: async () => {

    }
}

export let generator = {
    name: '${pluginName}',
    action: async () => {
        
    }
}
`

    return file
}